import type { QuickBooksCashPlanningRow } from '../../../data/ServerApiClient'
import { trimStr } from './cfoFormat'
import { signedCashAmount } from './cfoCashTableModel'

export const cashPlanningDocumentIdFor = (row: QuickBooksCashPlanningRow): string | null => {
  const sourceType = trimStr(row.source_type || '').toLowerCase()
  const isDocumentBacked =
    sourceType === 'invoice' || sourceType === 'bill' || sourceType === 'ar_invoice' || sourceType === 'ap_bill'
  if (!isDocumentBacked) return null
  const key = trimStr(row.source_key || '')
  if (!key) return null
  const segments = key.split(':')
  const id = segments.length >= 2 ? segments[1] : segments[0]
  return id && !['base', 'manual'].includes(id.toLowerCase()) ? id : null
}

/**
 * The WHOLE document's forecast cash across every week, not just the cell you
 * clicked.
 *
 * A document is split into three lag-quantile legs (25% at p25, 50% at p50, 25%
 * at p75) which routinely land in different weeks. The drill only ever receives
 * one cell's rows, but the server's suppression drops EVERY leg for the
 * document across the whole horizon once an expectation claims it. Sending the
 * clicked cell's subtotal therefore books a fraction and deletes the rest — so
 * a move must always carry the full document.
 */
export const documentTotalFor = (
  rows: QuickBooksCashPlanningRow[],
  documentId: string,
): number => {
  const target = trimStr(documentId).toLowerCase()
  if (!target) return 0
  let total = 0
  for (const row of rows) {
    if (row.row_kind === 'expectation' || row.row_kind === 'bridge') continue
    const id = cashPlanningDocumentIdFor(row)
    if (id && id.toLowerCase() === target) total += signedCashAmount(row)
  }
  return total
}
